<template>
    <div class="contentHome">
        <div class="centerPage">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
                <el-breadcrumb-item>
                    <a href="javascript:void(0);" @click="$router.push('/lecture')" class="aHref">专家讲座</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item>讲座详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="newLect flex">
                <div class=" img" :style="'backgroundImage: url('+details.thumbnailPath+')'"></div>
                <div class="rightC">
                    <h1 class="overflow">{{details.title}}</h1>
                    <div class="program">
                        <p><label class="line"></label>{{details.subTitle}}</p>
                    </div>
                    <div class="endTime">
                        <span>{{details.registerCount}}人已观看</span>
                    </div>
                </div>
            </div>
            <div class="detailCon">
                <div class="indicationsTit">
                    <span class="tit">讲座介绍</span>
                    <p>{{details.briefDesc}}</p>
                </div>
                <div class="indicationsTit">
                    <span class="tit">讲座专家</span>
                    <div class="expert flex">
                        <div class="swiperImg flex" v-for="(item,index) in details.doctors" :key="index">
                            <img :src="item.headImgPath" alt="" height="100%">
                            <div>
                                <strong>{{item.fullName}}</strong><br/>
                                <span>咨询专长：{{item.indications | indicationFmt}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="indicationsTit">
                    <span class="tit">讲座说明</span>
                    <div v-html="details.explanation"></div>
                </div>
            </div>
            <el-button class="joinUs" @click="videoPlay">查看视频</el-button>
        </div>


        <el-dialog width="760px"
                   :title="details.title"
                   :visible.sync="dialogVideo"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false"
                   :before-close="closeDialog">
         <video :src="details.videoPath" controls autoplay width="100%" ref="dialogVideoEle"></video>
        </el-dialog>

    </div>
</template>

<script>
    import base from '@/api/common';
    export default {
        name: "lectureDetails_video",
        data() {
            return {
                id: this.$route.params.id,
                details:{},

                isRegistered: 0,
                stateText:'',
                state: 0,

                dialogVideo: false
            }
        },
        mounted() {
            if(this.id){
                this.$ajax.get(base.manager_api.expert.lecture.details.replace("{id}",this.id)).then((res)=>{
                    if(res.data.status === 'success'){
                        this.details = res.data.data;
                    }
                }).catch((err)=>{
                    this.$message.error("数据加载失败");
                })
            }
        },
        methods: {
            videoPlay(){
                this.dialogVideo = true;
                // 观看人数增加
                // this.$ajax.post(base.api.expert.lecture.videoViews.replace("{id}",this.id));
			},
            closeDialog(done){
                this.$refs.dialogVideoEle.pause();
                done();
            },
        },
        filters:{
            indicationFmt(indications){
                if (indications && indications.length > 0) {
                    let arr = [];
                    $(indications).each((i, o) => {
                        arr.push(o.cnName);
                    })
                    return arr.join("、");
                }
                return "";
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../assets/css/medication.scss';

	.newCon {
		margin-top: 20px;
	}

	.endTime {
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #656565;

		span:last-child {
			color: #FB7B65;
		}
	}

	.joinUs[data-type='1'],.joinUs[data-type='1']:hover{
		color: #fff;
		background-color: #FFAD57;
		border-color: #FFAD57;}
	.joinUs[data-type='2'],.joinUs[data-type='2']:hover {
		color: #fff;
		background-color: #f56c6c;
		border-color: #f56c6c;
	}
	.joinUs[data-type='3'],.joinUs[data-type='3']:hover {
		color: #fff;
		background-color: #909399;
		border-color: #909399;
	}
</style>